import { useEffect, useState } from "react";
import TopNavbar from "../../components/AdminPortal/TopNavbar";
import { useSidebar } from "../../context/SidebarContext";
import Details from "../../components/AdminPortal/CRM-approval/Details";
import EvaluationScoreBoard from "../../components/AdminPortal/CRM-approval/EvaluationScoreBoard";
import PersonalDetails from "../../components/AdminPortal/CRM-approval/PersonalDetails";
import FinancialDetails from "../../components/AdminPortal/CRM-approval/FinancialDetails";
import SubmittedDocuments from "../../components/AdminPortal/CRM-approval/SubmittedDocuments";
import AmountApprove from "../../components/AdminPortal/CRM-approval/AmountApprove";
import ApprovedDetails from "../../components/AdminPortal/CRM-approval/ApprovedDetails";
import ReviewDecision from "../../components/AdminPortal/CRM-approval/ReviewDecision";
import ApplicationStatus from "../../components/AdminPortal/CRM-approval/ApplicationStatus";
import AnalyzerFlow from "./AnalyzerFlow";
import LoanDetails from "../../components/AdminPortal/CRM-approval/LoanDetails";
import ReviewActions from "../../components/AdminPortal/CRM-approval/ReviewActions";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { crmAPI } from "../../services/AdminPortal/crmAPI";
import { useAuth } from "../../context/AuthContext";
import { notificationAPI } from "../../services/notificationAPI";
import ConfirmationDialog from "../../components/StaffPortal/ConfirmationDialog.jsx";
import BankingConfirmationDetails from "../../components/AdminPortal/CRM-approval/BankingConfirmationDetails";
import { creditAPI } from "../../services/CreditManagerPortal/creditApi";
import BankConfirmationModal from "../../components/AdminPortal/CRM-approval/BankingConfirmation";

const LoanApplicationView = () => {
  const { sidebarExpanded, isMobile } = useSidebar();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();
  const currentUserId = user?.id;
  const [application, setApplication] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [error, setError] = useState(null);
  const [loanDistributions, setLoanDistributions] = useState([]);
  const [distributionError, setDistributionError] = useState(null);
  const [distributionLoading, setDistributionLoading] = useState(false);
  const [isBankConfirmationModalOpen, setIsBankConfirmationModalOpen] =
    useState(false);
  const [selectedDistributionId, setSelectedDistributionId] = useState(null); // For bank approval confirmation
  const [isProcessingBankApproval, setIsProcessingBankApproval] =
    useState(false);
  const [sentToBank, setSentToBank] = useState(false);
  console.log("LoanApplicationView - id:", application);

  const handleBankApproval = async (distributionId) => {
    if (!id || !distributionId) {
      toast.error("Missing loan or distribution ID.");
      return;
    }
    setIsProcessingBankApproval(true);
    try {
      await crmAPI.selectFinalBankingPartner(id, distributionId);
      toast.success("Banking partner is selected successfully for Approval!");
      await handleBankSelected(); // Refresh application data
    } catch (err) {
      console.error("Error selecting final banking partner:", err);
      toast.error(
        err.response?.data?.message ||
          err.message ||
          "Failed to select banking partner."
      );
    } finally {
      setIsProcessingBankApproval(false);
    }
  };
  const [formData, setFormData] = useState({
    amountType: "requested",
    customAmount: "",
    processingOption: "internal",
    searchQuery: "",
    selectedCategories: [],
    selectedBanks: [],
    selectedPartners: [],
    selectedPartnerIds: [],
    bankName: "Lono Micro Finance Bank",
    note: "",
  });
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const openConfirmDialog = (distributionIdToApprove) => {
    setIsDialogOpen(true);
    setSelectedDistributionId(distributionIdToApprove);
  };

  const closeConfirmDialog = () => {
    setIsDialogOpen(false);
  };

  // const updateStatus = async (newStatus) => { // This function seems to be for general status updates
  //   await handleLoanStatusChange(newStatus);
  // };

  const sendNotification = async (
    userId,
    note,
    notificationType,
    senderUserId
  ) => {
    try {
      const notification = await notificationAPI.sendNotification(
        userId,
        note,
        notificationType,
        senderUserId
      );
      toast.success(`Notification sent: ${note}`);
      console.log("Notification sent:", notification);
    } catch (error) {
      console.error("Error sending notification:", error);
      toast.error("Could not send notification.");
    }
  };

  useEffect(() => {
    let isMounted = true;

    const fetchInitialData = async () => {
      if (!isMounted) return;
      setLoading(true);
      setError(null);

      try {
        const [leadData, documentsData] = await Promise.all([
          crmAPI.getLeadById(id),
          crmAPI.getLeadDocuments(id),
        ]);

        if (!isMounted) return;

        if (!leadData) throw new Error("Lead not found");
        setApplication({ ...leadData });
        setSentToBank(leadData.sentToBank);

        if (!documentsData) throw new Error("Documents not found");
        setDocuments(documentsData);
      } catch (err) {
        if (!isMounted) return;
        console.error("Error fetching initial data:", err);
        setError({
          message: err.message || "Failed to load initial application data",
          details: err.response?.data || null,
        });
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchInitialData();

    const pollLeadDetails = async () => {
      try {
        const leadData = await crmAPI.getLeadById(id);
        if (isMounted && leadData) {
          setApplication((prevApp) => ({ ...prevApp, ...leadData }));
          if (application && application.sentToBank !== leadData.sentToBank) {
            setSentToBank(leadData.sentToBank);
          }
        }
      } catch (pollError) {
        if (isMounted) {
          console.error("Error polling lead details:", pollError);
        }
      }
    };

    const pollInterval = setInterval(pollLeadDetails, 5000);

    return () => {
      isMounted = false;
      clearInterval(pollInterval);
    };
  }, [id]); // REMOVED 'application' from dependency array

  useEffect(() => {
    const fetchLoanDistributions = async () => {
      if (id && sentToBank) {
        setDistributionLoading(true);
        setDistributionError(null);
        try {
          console.log(id);
          const distributionsData = await creditAPI.getLoanDistributions(id);
          console.log("Loan distributions:", distributionsData);
          setLoanDistributions(distributionsData || []);
        } catch (err) {
          console.error("Error fetching loan distributions:", err);
          setDistributionError(
            err.message || "Failed to load distribution details"
          );
          setLoanDistributions([]);
        } finally {
          setDistributionLoading(false);
        }
      } else {
        setLoanDistributions([]);
      }
    };

    fetchLoanDistributions();
  }, [id, sentToBank]);

  const layoutStyles = {
    marginLeft: isMobile ? "0" : sidebarExpanded ? "200px" : "60px",
    width: isMobile
      ? "100%"
      : `calc(100% - ${sidebarExpanded ? "200px" : "60px"})`,
  };

  const handleLoanStatusChange = async (newStatus, rejectionReason = null) => {
    setLoading(true);
    try {
      await crmAPI.updateLoanStatus(id, newStatus, rejectionReason);
      setApplication((prevApplication) => ({
        ...prevApplication,
        status: newStatus,
      }));
    } catch (error) {
      console.error("Error updating loan status:", error);
    } finally {
      setLoading(false);
    }
  };
  const sendBulkNotifications = async (userIds, note) => {
    try {
      const notification = await notificationAPI.sendBulkNotifications(
        userIds,
        note
      );
      console.log("Notification sent:", notification);
      setNote(""); // Clear the note after sending
    } catch (error) {
      console.error("Error sending notification:", error);
    }
  };
  const handleOpenBankConfirmation = () => {
    setIsBankConfirmationModalOpen(true);
  };

  const handleBankSelected = async () => {
    await crmAPI.getLeadById(id).then((leadData) => {
      if (leadData) setApplication((prev) => ({ ...prev, ...leadData }));
    });
  };

  // Find the finally approved distribution
  const finalApprovedDistribution =
    application?.status === "approved" && application?.bankingPartner
      ? loanDistributions.find(
          (dist) =>
            dist.bankingPartner?._id === application.bankingPartner &&
            dist.status === "approved"
        )
      : null;
  const navigate = useNavigate();

  useEffect(() => {
    const getDocumnetsById = async () => {
      setLoading(true);
      try {
        // Single API call that includes populated documents
        const documentsData = await crmAPI.getLeadDocuments(id);
        console.log("documentsData", documentsData);
        if (!documentsData) {
          throw new Error("Documents not found");
        }

        setDocuments(documentsData);
      } catch (error) {
        console.error("Error fetching documents:", error);
        setError({
          message: error.message || "Failed to load documents",
          details: error.response?.data || null,
        });
        toast.error(error.message || "Failed to load documents");
      } finally {
        setLoading(false);
      }
    };
    const getLeadDetailsById = async () => {
      setLoading(true);
      try {
        // Single API call that includes populated documents
        const leadData = await crmAPI.getLeadById(id);

        if (!leadData) {
          throw new Error("Lead not found");
        }
        setSentToBank(leadData.sentToBank);

        setApplication({
          ...leadData,
          // If you need to transform the documents data:
        });
      } catch (error) {
        console.error("Error fetching lead details:", error);
        setError({
          message: error.message || "Failed to load lead details",
          details: error.response?.data || null,
        });
        toast.error(error.message || "Failed to load lead details");
      } finally {
        setLoading(false);
      }
    };
    getLeadDetailsById();
    getDocumnetsById();
  }, [id]);

  if (loading) {
    return (
      <div className="min-h-screen bg-black text-white flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-yellow-500"></div>
      </div>
    );
  }

  // Show error state
  if (error && !application) {
    return (
      <div className="min-h-screen bg-black text-white flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl text-red-500 mb-4">Error: {error.message}</h2>
          <button
            onClick={() => window.location.reload()}
            className="bg-[#FFCA20] text-black px-4 py-2 rounded"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }
  return (
    <div
      className="min-h-screen  bg-black text-white   mt-12"
      style={layoutStyles}
    >
      <TopNavbar />
      <div className="p-4 ">
        <div className="mb-4 flex flex-wrap items-center justify-start gap-4">
          <h1 className="text-[#FFCA20] font-bold text-md hover:underline">
            <span
              className="text-[#FFCA20] cursor-pointer"
              onClick={() => {
                const role = user?.role?.toLowerCase();
                if (["admin", "subadmin"].includes(role)) {
                  navigate(`/${role}/customers`);
                } else {
                  console.warn("Unknown role:", role);
                }
              }}
            >
              Loan Applications
            </span>
          </h1>
          <span>{">"}</span>
          <h2 className="text-white font-medium text-md">Application Review</h2>
        </div>
        {/* universal analyser banner */}
        <div className="bg-[#208FFF33] p-3 mb-4 rounded-lg border border-[#333333]">
          <div className="flex flex-col sm:flex-row justify-between items-center  ">
            <div className="flex-1">
              <h4 className="text-white text-base font-medium">
                Review and analyse the submitted loan application with detailed
                insights.
              </h4>
            </div>
            <button
              onClick={() => {
                const role = user?.role?.toLowerCase();
                if (["admin", "subadmin", "credit-manager"].includes(role)) {
                  navigate(`/${role}/universal-analysers/${id}`);
                } else {
                  console.warn("Unknown role:", role);
                }
              }}
              className=" text-[#57ABFF] rounded-lg flex items-center gap-2 transition-colors"
            >
              <span>Run Universal Analyser</span>
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </div>
        </div>

        <div className="w-full mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
            {/* Left Section */}
            <div className="lg:col-span-2 space-y-4">
            

              <Details application={application} />
              <EvaluationScoreBoard loanId={id} application={application} />
              <div className="grid grid-cols-1 md:grid-cols-2 divide-x divide-[#333333]">
                <PersonalDetails application={application} />
                <FinancialDetails loanId={id} application={application}/>
              </div>

              <SubmittedDocuments
                application={application}
                setDocuments={setDocuments}
                leadId={id}
                documents={documents}
              />

              {application?.status === "processing" && !sentToBank && (
                <AmountApprove formData={formData} setFormData={setFormData} />
              )}

              {application?.status === "approved" && (
                <ApprovedDetails
                  distribution={finalApprovedDistribution}
                  application={application}
                />
              )}
            </div>

            {/* Right Section */}
            <div className="lg:col-span-1 space-y-4">
              <div className="h-72 overflow-y-auto bg-[#1F1F1F] p-1 rounded-lg">
                <ApplicationStatus application={application} />
              </div>
              {/* analyzer flow component */}
              <AnalyzerFlow loanId={id} />
              {/* loan details component */}
              <LoanDetails application={application} />
              {application?.status === "processing" && !sentToBank && (
                <ReviewDecision
                  application={application}
                  handleLoanStatusChange={handleLoanStatusChange}
                  onSendToBank={handleOpenBankConfirmation}
                />
              )}
            </div>
            <div className="lg:col-span-3 relative space-y-2 ">
              {!["processing", "rejected", "approved"].includes(
                application?.status
              ) && (
                <ReviewActions
                  application={application}
                  handleLoanStatusChange={handleLoanStatusChange}
                  documents={documents}
                />
              )}
            </div>

          </div>

          {/* Full Width Banking Confirmation Details Section */}
          {/* Show if status is 'processing' and sentToBank OR if status is 'approved' and a final partner is selected */}
          {/* Hide if application status is 'approved' */}
          {application?.status !== "approved" &&
          application?.status === "processing" &&
          sentToBank ? (
            <div className="mt-8">
              {" "}
              {/* Added margin-top for spacing */}
              <BankingConfirmationDetails
                application={application}
                handleBankApproval={handleBankApproval}
                openConfirmDialog={openConfirmDialog}
                distributions={
                  application?.status === "approved" &&
                  application?.bankingPartner
                    ? loanDistributions.filter(
                        (dist) =>
                          dist.bankingPartner?._id ===
                          application.bankingPartner
                      )
                    : loanDistributions
                }
                error={distributionError}
                loading={distributionLoading}
                isProcessingApproval={isProcessingBankApproval}
                // loanId={id}
                onBankSelected={handleBankSelected}
              />
            </div>
          ) : null}
        </div>
      </div>
      {isBankConfirmationModalOpen && application?.status !== "approved" && (
        <BankConfirmationModal
          onClose={() => setIsBankConfirmationModalOpen(false)}
          onConfirm={async () => {
            let partnerDistributions = [];
            if (formData.processingOption === "internal" && formData.bankName) {
              const internalBankPartnerId = "YOUR_INTERNAL_BANK_PARTNER_ID";
              if (internalBankPartnerId === "YOUR_INTERNAL_BANK_PARTNER_ID") {
                console.warn(
                  "User action blocked: Internal bank configuration missing. Please replace 'YOUR_INTERNAL_BANK_PARTNER_ID'."
                );
                setIsBankConfirmationModalOpen(false);
                return;
              }
              partnerDistributions.push({
                partnerId: internalBankPartnerId,
                note: formData.note,
              });
              setSentToBank(true);
            } else {
              partnerDistributions = (formData.selectedBanks || [])
                .map((p) => {
                  if (
                    !p.value ||
                    typeof p.value !== "string" ||
                    !/^[0-9a-fA-F]{24}$/.test(p.value)
                  ) {
                    console.warn(
                      `Invalid partnerId found: '${p.value}' for partner/bank: '${p.label}'. Expected a MongoDB ObjectId. Skipping this entry.`
                    );

                    return null;
                  }
                  return {
                    partnerId: p.value,
                    note: formData.note,
                  };
                })
                .filter((p) => p !== null);
            }

            const representativeIds =
              formData.selectedPartners && formData.selectedPartners.length > 0
                ? formData.selectedPartners.map((p) => p.value)
                : [];

            console.log(
              "Frontend - LoanApplicationView - Preparing to send partnerDistributions:",
              JSON.stringify(partnerDistributions, null, 2)
            );
            try {
              setLoading(true);
              await crmAPI.distributeLoanAndUpdateAmount(id, {
                partnerDistributions,
                amountType: formData.amountType,
                customAmount:
                  formData.amountType === "custom"
                    ? parseFloat(formData.customAmount)
                    : undefined,
                representativeIds,
              });
              await sendBulkNotifications(
                formData.bankingPartnerIds,
                "New application is sent to you from Credit Manager."
              );
              setSentToBank(true); // Set sentToBank to true after successful distribution
              // await crmAPI.distributeLoanToBanks(id, {
              //   partnerDistributions,
              // });
              // toast.success("Loan successfully sent for processing!"); // Assuming toast is defined
              handleLoanStatusChange("processing"); // Or "sent-to-bank" or a relevant status
              toast.success(
                "Loan Application is successfully sent to slected Banks!"
              );
            } catch (apiError) {
              toast.error("failed to send loan Application to banks");
              console.error("Error distributing loan:", apiError);
            } finally {
              setLoading(false);
            }
            setIsBankConfirmationModalOpen(false);
          }}
          selectedBanks={
            formData.processingOption === "internal"
              ? [
                  {
                    name: formData.bankName,
                    branch: "Internal Processing",
                    city: "Lono Office",
                  },
                ]
              : (formData.selectedBanks || []).map((b) => ({
                  name: b.label /* add branch/city if available */,
                }))
          }
          selectedRepresentatives={(formData.selectedPartners || []).map(
            (p) => ({ name: p.label.split("(")[0].trim(), details: p.label })
          )}
        />
      )}
      <ConfirmationDialog
        isOpen={isDialogOpen}
        onClose={closeConfirmDialog}
        onConfirm={async () => {
          if (!selectedDistributionId) {
            toast.error("No bank distribution selected for approval.");
            closeConfirmDialog();
            return;
          }
          await handleBankApproval(selectedDistributionId);

          const applicantUserId =
            application?.userId || application?.leadData?.userId; // Adjust path as per your application object

          let bankNameForNotification = "the selected bank";
          // After handleBankApproval, application state is refreshed by handleBankSelected.
          // Try to find the approved bank's name from the updated application or loanDistributions.
          if (application?.bankingPartner) {
            // This should be the ID of the final banking partner
            const finalPartnerDistribution = loanDistributions.find(
              (dist) => dist.bankingPartner?._id === application.bankingPartner
            );
            if (finalPartnerDistribution?.bankingPartner?.bankName) {
              bankNameForNotification =
                finalPartnerDistribution.bankingPartner.bankName;
            }
          } else {
            const approvedDistribution = loanDistributions.find(
              (d) => d._id === selectedDistributionId
            );
            if (approvedDistribution?.bankingPartner?.bankName) {
              bankNameForNotification =
                approvedDistribution.bankingPartner.bankName;
            }
          }

          if (applicantUserId && currentUserId) {
            sendNotification(
              applicantUserId,
              `Your loan application has been approved with ${bankNameForNotification}.`,
              "Credit Manager",
              currentUserId
            );
            sendNotification(
              application?.user?._id,
              `Your loan application has been approved.`,
              "System",
              currentUserId
            );
          }
          closeConfirmDialog();
        }}
        title="Confirm Bank Approval"
        message="Are you sure you want to approve this banking partner and proceed with this loan offer? This action cannot be undone."
      />
    </div>
  );
};

export default LoanApplicationView;
